import error from './errors';
import validate from './validates';
import menu from './menu';
import vuetify from './vuetify';

export default {
  error,
  validate,
  menu,
  $vuetify: vuetify,
  app: {
    title: 'BATS',
    account: 'Mi cuenta',
    settings: 'Configuración',
    logOut: 'Cerrar sesión'
  },
  login: {
    title: 'Ingrese como Usuario',
    title_nit: 'Ingrese como Administrador',
    user: 'Nombre de usuario',
    password: 'Contraseña',
    nit: 'NIT',
    rememberMe: 'Recuérdame',
    forgotPass: '¿Olvidó su contraseña?',
    login: 'Ingresar',
    noAccount: '¿No tienes una cuenta?',
    signUp: 'Regístrate aquí'
  },
  common: {
    required_fields: 'Los campos son obligatorios',
    add: 'Agregar',
    required: 'Campo obligatorio',
    cancel: 'Cancelar',
    save: 'Guardar',
    rowsPage: 'Filas por página',
    updateList: 'Actualizar esta lista',
    filters: 'Filtros/búsqueda',
    of: 'de',
    active: 'Activo',
    observation: 'Observar',
    firm: 'Firmar',
    approve: 'Aprobar y Firmar',
    edit: 'Editar',
    status: 'Estado',
    actions: 'Acciones',
    close: 'Cerrar',
    general_information: 'Datos Generales',
    contact_information: 'Datos de contacto',
    other_information: 'Otros'
  },
  entity: {
    title: 'Entidades',
    add: 'Agregar nueva entidad',
    crud: {
      edit: 'Editar',
      code: 'Código',
      name: 'Nombre',
      acronym: 'Sigla',
      description: 'Descripción',
      status: 'Estado',
      addEnt: 'Agregar entidad',
      editEnt: 'Editar entidad',
      address: 'Dirección',
      email: 'Correo electrónico de atención al cliente',
      phones: 'Teléfono(s)',
      web: 'Página web de la entidad',
      user_data: 'Datos de usuario recuperables'
    }
  },
  account: {
    title: 'Cuentas',
    add: 'Agregar nueva cuenta',
    select: 'Seleccione una entidad para ver sus cuentas',
    crud: {
      edit: 'Editar',
      accountNumber: 'Nro. de cuenta',
      status: 'Estado',
      entity: 'Entidad',
      addAc: 'Agregar cuenta',
      editAc: 'Editar cuenta'
    }
  },
  user: {
    title: 'Usuarios',
    add: 'Agregar nuevo usuario',
    crud: {
      edit: 'Editar',
      user: 'Usuario',
      userData: 'Datos del usuario',
      entity: 'Entidad',
      role: 'Rol',
      status: 'Estado',
      addUser: 'Agregar usuario',
      editUser: 'Editar usuario',
      fullname: 'Nombre completo',
      email: 'Correo electrónico'
    }
  },
  rol: {
    title: 'Roles',
    add: 'Agregar nuevo rol',
    crud: {
      name: 'Nombre',
      description: 'Descripción',
      tipo: 'Tipo',
      path: 'Ruta',
      editRol: 'Editar Rol',
      addRol: 'Agregar Rol'
    }
  },
  parametro: {
    title: 'Parámetros',
    add: 'Agregar nuevo parámetro',
    preferencias: 'Preferencias',
    crud: {
      name: 'Nombre',
      value: 'Valor',
      label: 'Label',
      description: 'Descripción',
      editParametro: 'Editar Parámetro',
      addParametro: 'Agregar Parámetro'
    }
  },
  module: {
    title: 'Módulos y permisos',
    add: 'Agregar nuevo módulo',
    crud: {
      edit: 'Editar',
      module: 'Módulo padre',
      label: 'Título',
      path: 'Path',
      icon: 'Ícono',
      order: 'Orden',
      status: 'Estado',
      visible: 'Visible',
      is_visible: 'Es visible',
      submodule: 'Sub módulo',
      section: 'Sección',
      addModule: 'Agregar módulo',
      editModule: 'Editar módulo',
      permissions: 'Permisos'
    }
  },
  log: {
    title: 'Logs del sistema',
    crud: {
      nivel: 'Nivel',
      tipo: 'Tipo',
      mensaje: 'Mensaje',
      referencia: 'Referencia',
      ip: 'IP',
      path: 'Ruta',
      fecha: 'Fecha de creación',
      usuario: 'Usuario'
    }
  },
  servicioIop: {
    title: 'Interoperabilidad',
    add: 'Agregar nuevo servicio',
    crud: {
      codigo: 'Código',
      metodo: 'Método',
      descripcion: 'Descripción',
      entidad: 'Entidad',
      url: 'Url',
      token: 'Token',
      tipo: 'Tipo',
      estado: 'Estado',
      editServicio: 'Editar Servicio Iop',
      addServicio: 'Agregar Servicio Iop'
    }
  },
  canales: {
    title: 'Canales de Comunicación',
    add: 'Agregar nuevo Canal',
    crud: {
      mensaje_bienvenida: 'Mensaje de bienvenida / respuesta inmediata',
      edit: 'Editar',
      code: 'Código',
      clasificacion: 'Clasificación',
      usuario: 'Usuario',
      description: 'Descripción',
      status: 'Estado',
      agregarRegistro: 'Agregar Canal de Comunicación',
      editarRegistro: 'Modificar Canal de Comunicación',
      ruta_perfil: 'Ruta Perfil',
      twitter_id: 'Twitter ID',
      servidor: 'Servidor de Correo',
      sesion_id: 'ID de sesión',
      sesion_url: 'URL de sesión',
      servidor_smtp: 'Servidor SMTP',
      puerto_smtp: 'Puerto SMTP'
    }
  },
  chat: {
    title: 'Conversaciones',
    verificacion: 'Verificación de datos',
    ver_persona: 'Datos de persona'
  },
  tramites: {
    title: 'Trámites',
    add: 'Agregar nuevo trámite',
    label: 'Trámite',
    quick_response: 'Respuesta rápida',
    crud: {
      nombre_tramite: 'Nombre de trámite',
      entidad: 'Entidad'
    }
  },
  faqs: {
    title: 'Preguntas frecuentes',
    add: 'Agregar pregunta',
    list: 'Listado de preguntas frecuentes'
  },
  operadores: {
    crud: {
      tipo: 'Tipo',
      persona: 'Persona / Canal',
      descripcion: 'Descripción'
    },
    historial: 'Historial',
    pendientes: 'Pendientes',
    conversacion: 'Conversación',
    ingresar: 'Ingresar a la Conversación',
    cubiculo: {
      iniciar: 'Seleccione un punto de atención',
      cambiar: 'Cambiar punto de atención',
      requerido: 'Debe seleccionar un punto de atención',
      salir: 'Salir del punto de atención actual'
    },
    caso: {
      resumen: 'Resumen'
    }
  },
  puntos_atencion: {
    titulo: 'Puntos de Atención',
    nodata: 'No hay puntos de atención',
    crud: {
      identificador: 'Identificador',
      entidad: 'Entidad'
    }
  },
  caso: {
    derivar: 'Derivar caso',
    cerrar: 'Cerrar caso',
    adjuntar: 'Adjuntar Caso',
    canal_principal: 'Este es el canal principal',
    crud: {
      tipo: 'Tipo de caso',
      nombre_completo: 'Nombre',
      nro_documento: 'Documento',
      telefono: 'Teléfono',
      movil: 'Celular',
      descripcion: 'Descripción',
      identificador: 'Punto de atención',
      ultimo_mensaje: 'Último mensaje',
      ultima_actualizacion: 'Última actualización'
    }
  },
  persona: {
    agregar_dato: 'Agregar un nuevo dato',
    remover_dato: 'Remover este dato'
  }
};



// WEBPACK FOOTER //
// ./src/common/lang/es/messages.js